module.exports = __webpack_public_path__ + "static/img/9.bad2f51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/set/5/9.jpg
// module id = 2Aea
// module chunks = 0